module.exports = __webpack_public_path__ + "img/logo-ct-white.fbdb6245.png";